var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-card lobby-ui"},[_c('img',{staticClass:"koala",attrs:{"src":"/static/koala-armsup.png"}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Hi!"),_c('br'),_vm._v("Let's play Uno!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db85aaba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lobby/IntroCard.vue
// module id = null
// module chunks = 